export const DYNAMICS_ENABLED = process.env.REACT_APP_DYNAMICS_ENABLED === 'true';
